import Data from 'app-core/Data';

function getCampaignProducts(pageIndex, limit, opts, campaignId) {
	return Data.getExternalApi('CampaignProduct/GetCampaignProducts', `campaignId=${campaignId}&page=${pageIndex + 1}`, limit);
}

export default {
	getCampaignProducts
};
